import { Form, Formik } from "formik";
import React, { useState } from "react";
import DropdownField from "../../../shared/DropdownField";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../shared/CustomButton";
import { FaCheckDouble } from "react-icons/fa";
import * as Yup from "yup";
import { fetchData } from "../../../helpers/fetchData";
import { getVisitsList } from "../../../redux/slices/VisitsSlice";
import { useDispatch } from "react-redux";
import moment from "moment";
import toast from "react-hot-toast";
import CheckPermission from "../../../hooks/CheckPermission";

function ExtednVisitTime({
  visit,
  setExtendModal,
  setExtendedVisit,
  getVisitDataPayload,
}) {
  const { hasPermission } = CheckPermission();
  const canExtend = hasPermission('visit', 'update') || hasPermission('appointments', 'update');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const initialValues = {
    visit_id: visit?.visit_id,
    no_of_slots: 1,
    description: "",
  };
  const validationSchema = Yup.object().shape({
    no_of_slots: Yup.number().required("No of slots is required"),
    description: Yup.string().trim().required("Description is required"),
  });
  const handleSubmit = async (values) => {
    if (!canExtend) return;
    setLoading(true);
    try {
      const res = await fetchData("POST", "v3/visit/extendSlotTime", {
        visit_id: visit?.visit_id,
        no_of_slots: values?.no_of_slots,
        description: values?.description,
      });
      if (res?.message) {
        setExtendModal(false);
        setExtendedVisit(null);
        toast.success(res?.message);
        let getPayload = {
          ...getVisitDataPayload,
          start_date: moment(getVisitDataPayload?.start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(getVisitDataPayload?.start_date).format(
            "YYYY-MM-DD"
          ),
        };
        dispatch(getVisitsList(getPayload));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {(props) => (
        <Form className="flex flex-col gap-4 justify-center items-center">
          <DropdownField
            label="No of Slots"
            name="no_of_slots"
            placeholder="select no of slots"
            options={[
              {
                value: 1,
                label: "1",
              },
              {
                value: 2,
                label: "2",
              },
              {
                value: 3,
                label: "3",
              },
            ]}
          />
          <div className={`flex flex-col gap-1 w-full mb-3 `}>
            <label className="input-label">{t("AddDescriprion")}</label>
            <textarea
              placeholder={t("Enterdescriprion")}
              className="bg-gray-100 border border-gray-300 p-2 rounded-lg text-[14px] w-full !outline-none !shadow-none hover:border-primary"
              name="description"
              value={props?.values?.description}
              rows={3}
              onChange={props?.handleChange}
            />
            {props?.errors?.description && props?.touched?.description && (
              <span className="text-red-500 text-sm">
                {props?.errors?.description}
              </span>
            )}
          </div>
          <div className="w-full flex items-center justify-end">
            {canExtend && (
            <CustomButton
              type="submit"
              loading={loading}
              className="mt-2"
              label={t("submit")}
              buttonType="primary"
              icon={<FaCheckDouble size={12} className="me-2" />}
            />
          )}</div>
        </Form>
      )}
    </Formik>
  );
}

export default ExtednVisitTime;
